import { useLayoutEffect } from 'react'
import searchInsights from 'search-insights'
import { useInstantSearch } from 'react-instantsearch'
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares'

const InsightsMiddleware = () => {
  const { addMiddlewares } = useInstantSearch()

  useLayoutEffect(() => {
    const middleware = createInsightsMiddleware({
      insightsClient: searchInsights,
    })

    return addMiddlewares(middleware)
  }, [addMiddlewares])

  return null
}

export default InsightsMiddleware
